// API Configuration - automatically detect environment based on hostname
const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'dev.onetrack.fi') {
      return 'https://dev.onetrack.fi/taskmanager/api';
    }
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8000/api';
    }
  }
  return 'https://www.onetrack.fi/taskmanager/api';
};

export const API_URL = getApiUrl();

// Re-export apiFetch from apiClient for convenience
export { apiFetch, apiCall } from '../utils/apiClient';
